<template>
  <div class="checklist-form-card" @click="$emit('click')">
    <div class="form-card-top">
      <div class="qrw-heading-xs qrw-text-content-base-primary bold card-title">
        {{ template.title || 'New form' }}
      </div>
      <div class="form-tags">
        <BaseTag size="sm" withIcon v-for="tag in template.tags" :key="tag">
          {{ tag }}
        </BaseTag>
      </div>
    </div>
    <div class="qrw-label-sm qrw-text-content-base-tertiary">
      {{ $t("checklists.last_edited") }}
      {{ template.updated_at | formatDatetime }}
    </div>

    <div class="circle-status-icon" :style="circleIconStyles"></div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    template: Object,
  },
  computed: {
    templateChangesStatus() {
      if (!this.template.published_at) return "draft";

      if (moment(this.template.published_at).isBefore(
        this.template.blocks_updated_at
      )) return 'edited';

      return "published";
    },
    circleIconStyles() {
      const colors = {
        draft: "grey-3",
        published: "green-5",
        edited: 'orange-4'
      };

      return {
        "background-color": `var(--${
          colors[this.templateChangesStatus]
        }-color)`,
      };
    },
  },
};
</script>

<style scoped>
.checklist-form-card {
  border-radius: 12px;
  display: flex;
  padding: 16px 20px 16px 20px;

  position: relative;

  box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.16);

  flex-direction: column;
  row-gap: 16px;

  background: var(--white-color);

  box-sizing: border-box;

  width: 336px;

  cursor: pointer;
}

.checklist-form-card:hover {
  box-shadow: 0px 3px 6px 3px rgba(0, 0, 0, 0.16);
}

.form-card-top {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}

.form-tags {
  display: flex;
  align-items: center;
  flex-direction: row;
  column-gap: 6px;
  flex-wrap: wrap;
  row-gap: 8px;
}

.circle-status-icon {
  position: absolute;
  top: 12px;
  right: 12px;

  width: 8px;
  height: 8px;
  display: block;

  border-radius: 50%;
}

.card-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}
</style>
